import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { AlertService } from 'src/app/services/alert.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { InputformatService } from 'src/app/services/inputformat.service';
import { AttachmentType } from 'src/enum/attachmentType.enum';
import { FileType } from 'src/enum/fileType.enum';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-paccsserviceprovidereditapproval',
  templateUrl: './paccsserviceprovidereditapproval.component.html',
  styleUrls: ['./paccsserviceprovidereditapproval.component.scss']
})
export class PaccsserviceprovidereditapprovalComponent implements OnInit {

  form!: FormGroup;
  editForm!: FormGroup;
  districtList: any = [];
  talukList: any = [];
  blockList: any = [];
  villageList: any = [];
  genderList: any = [];
  paccsTypeList: any = [];
  attachmentData: any[] = [];
  passBookattachmentData: any[] = [];
  formDataPatchValue: any
  isAccountVerified: any;
  fileName: any;
  userImagefileName: any;
  dateWithTime: string;
  dateWithTime1: string;
  FileExtention: any;
  FileExtention1: any
  BannerImage: File;
  BannerImage1: File;
  userImageBase64: string;
  attachmentType = AttachmentType;
  fileTypeEnum = FileType;
  bannerImageSrc: string | null = null;
  bannerImageSrc1: string | null = null;
  public imageBaseUrl = environment.imageBaseUrl;
  paccsApprovedStatusType: any;
  showData: boolean;
  userFileName: string;
  aadhaarFileName: string;
  passbookfileName: string

  constructor(private inputFormatService: InputformatService,
    private formBuilder: FormBuilder,
    private cashBookingService: CashBookingService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<PaccsserviceprovidereditapprovalComponent>,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef
  ) {
    this.formDataPatchValue = this.dialogData.data
    this.isAccountVerified = this.dialogData.data.isAccountVerified
    this.paccsApprovedStatusType = this.dialogData.data.paccsApprovedStatusType
  }

  ngOnInit() {
    this.initialValidators();
    this.genderLookup();
    this.getPaccsType();
    this.form.patchValue(this.formDataPatchValue)
    this.loadDataFromPayloadaadhaar(this.dialogData.data.attachment)
    this.loadDataFromPayloadImage(this.dialogData.data.userImagePath)
  }


  initialValidators() {
    this.form = this.formBuilder.group({
      id: [0],
      paccsType: [null, Validators.required],
      ePaccsRefNo: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{14}$'),
        Validators.minLength(14),
        Validators.maxLength(14)
      ]],
      secretaryName: [null, [Validators.required, Validators.pattern(/^[A-Za-z\u0B80-\u0BFF ]+$/)]],
      genderType: [null, [Validators.required]],
      mobileNo: [null, [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]],
      aadharNo: ['', [
        Validators.required,
        Validators.pattern(/^[0-9]{12}$/)
      ]],

      attachment: [null, Validators.required],
      userImagePath: [null, Validators.required]
    });
  }

  back() {

  }

  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }

  genderLookup() {
    this.cashBookingService.getGenderType(true).subscribe((res) => {
      this.genderList = res;
    });
  }


  closeDialog(): void {
    const closeDlg = { isClosed: true }
    this.dialogRef.close(closeDlg);
  }

  getPaccsType() {
    this.cashBookingService.getCooperativeInstitution().subscribe((res) => {
      this.paccsTypeList = res;
    });
  }

  allowOnlyPositiveIntegers(event: KeyboardEvent): void {
    const inputChar = event.key;

    // Block non-digits only
    if (!/^\d$/.test(inputChar)) {
      event.preventDefault();
      return;
    }
  }

  submit() {
    // Prepare Aadhaar attachment
    const aadhaarAttachment = this.attachmentData.map((v) => {
      return {
        ...v,
        base64String: v.base64String.replace(
          /^data:image\/(png|jpeg|jpg|PNG|JPEG|JPG);base64,/,
          ''
        )
      };
    });

    // Prepare Secretary Image attachment
    const userImageAttachment = this.passBookattachmentData.map((v) => {
      return {
        ...v,
        base64String: v.base64String.replace(
          /^data:image\/(png|jpeg|jpg|PNG|JPEG|JPG);base64,/,
          ''
        )
      };
    });

    if (this.form.get('paccsType')?.value != 1) {
      this.form.controls['ePaccsRefNo'].setValue("");
      this.form.controls['ePaccsRefNo'].clearValidators();
      this.form.controls['ePaccsRefNo'].updateValueAndValidity();
    }
    if (this.form.valid) {
      const payload = {
        ServiceProviderId: this.form.value.id,
        PaccsType: this.form.value.paccsType,
        EPaccsRefNo: this.form.value.ePaccsRefNo,
        SecretaryName: this.form.value.secretaryName,
        GenderType: this.form.value.genderType,
        MobileNo: this.form.value.mobileNo,
        AadharNo: this.form.value.aadharNo,
        Attachment: aadhaarAttachment.concat(userImageAttachment)
      };
      this.cashBookingService.userDetailsUpdate(payload).subscribe((result) => {
        if (result) {
          this.dialogRef.close(result)
        } else {
          this.alertService.error('error')
        }
      })
    } else {
      this.form.markAllAsTouched()
      this.alertService.error('Please fill in the mandatory fields')
    }
  }


  // Aadhaar Upload
  selectFile(): void {
    if (!this.fileName) {
      this.form.controls['attachment'].markAsTouched();

      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.accept = '.png,.jpg,.jpeg,.pdf';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();

      inputElement.addEventListener('change', (event) => {
        const files = (event.target as HTMLInputElement).files;
        if (!files || files.length === 0) return;

        const file = files[0];
        this.fileName = file.name;

        const fileExtension = this.fileName.split('.').pop()?.toLowerCase() || '';
        if (!['png', 'jpg', 'jpeg', 'pdf'].includes(fileExtension)) {
          Swal.fire('Warning', 'Please upload a Correct File Format (PNG, JPEG, JPG, PDF)', 'warning');
          this.fileName = '';
          this.form.controls['attachment'].setValue('');
          return;
        }

        const existingIndex = this.attachmentData.findIndex(
          (v) => v.attachmentType === this.attachmentType.Aadhar
        );
        if (existingIndex !== -1) {
          this.attachmentData.splice(existingIndex, 1);
        }

        if (file.size > 2 * 1024 * 1024) { // 2MB
          Swal.fire('Warning', 'The file being uploaded can\'t be more than 2MB', 'warning');
          this.fileName = '';
          this.form.controls['attachment'].setValue('');
          return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result as string;
          const fileType = fileExtension === 'pdf' ? this.fileTypeEnum.Pdf : this.fileTypeEnum.Image;

          // show preview
          this.bannerImageSrc = base64;

          this.attachmentData = [{
            id: 0,
            base64String: base64,
            attachmentFilename: this.fileName,
            fileType: fileType,
            attachmentType: this.attachmentType.Aadhar, // 35
          }];

          this.form.controls['attachment'].setValue(this.fileName);
        };

        reader.readAsDataURL(file);
        document.body.removeChild(inputElement);
      });
    }
  }

  selectFile1(): void {
    if (!this.userFileName) {
      this.form.controls['userImagePath'].markAsTouched();

      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.accept = '.png,.jpg,.jpeg';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();

      inputElement.addEventListener('change', (event) => {
        const files = (event.target as HTMLInputElement).files;
        if (!files || files.length === 0) return;

        const file = files[0];
        this.userFileName = file.name;

        const fileExtension = this.userFileName.split('.').pop()?.toLowerCase() || '';
        if (!['png', 'jpg', 'jpeg'].includes(fileExtension)) {
          Swal.fire('Warning', 'Please upload a Correct File Format (PNG, JPEG, JPG)', 'warning');
          this.userFileName = '';
          this.form.controls['userImagePath'].setValue('');
          return;
        }

        if (file.size > 2 * 1024 * 1024) { // 2MB
          Swal.fire('Warning', 'The file being uploaded can\'t be more than 2MB', 'warning');
          this.userFileName = '';
          this.form.controls['userImagePath'].setValue('');
          return;
        }

        const existingIndex = this.attachmentData.findIndex(
          (v) => v.attachmentType === this.attachmentType.User
        );
        if (existingIndex !== -1) {
          this.attachmentData.splice(existingIndex, 1);
        }

        const reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result as string;
          const fileType = fileExtension === 'pdf' ? this.fileTypeEnum.Pdf : this.fileTypeEnum.Image;

          // show preview
          this.bannerImageSrc1 = base64;

          this.passBookattachmentData = [{
            id: 0,
            base64String: base64,
            attachmentFilename: this.userFileName,
            fileType: fileType,
            attachmentType: this.attachmentType.User, // 69
          }];

          this.form.controls['userImagePath'].setValue(this.userFileName);
        };

        reader.readAsDataURL(file);
        document.body.removeChild(inputElement);
      });
    }
  }

  loadDataFromPayloadaadhaar(attachmentPath: any): void {
    this.fileName = attachmentPath
      ? attachmentPath.split('/').pop()
      : '';
    const fileExtension = this.fileName?.split('.').pop()?.toLowerCase();
    this.form.controls['attachment'].setValue(this.fileName);

    this.FileExtention = fileExtension;
    if (attachmentPath) {
      if (this.isImageFile(fileExtension)) {
        this.FileExtention = fileExtension;
        this.bannerImageSrc = `${this.imageBaseUrl}/${attachmentPath}`;
      } else {
        this.bannerImageSrc = null;
      }
    } else {
      this.bannerImageSrc = null;
    }
  }

  loadDataFromPayloadImage(attachmentPath: any): void {
    this.userFileName = attachmentPath
      ? attachmentPath.split('/').pop()
      : '';
    const fileExtension = this.userFileName?.split('.').pop()?.toLowerCase();
    this.form.controls['userImagePath'].setValue(this.userFileName);

    this.FileExtention1 = fileExtension;
    if (attachmentPath) {
      if (this.isImageFile(fileExtension)) {
        this.FileExtention1 = fileExtension;
        this.bannerImageSrc1 = `${this.imageBaseUrl}/${attachmentPath}`;
      } else {
        this.bannerImageSrc1 = null;
      }
    } else {
      this.bannerImageSrc1 = null;
    }
  }

  isImageFile(path: any): boolean {
    const extension = path.split('.').pop()?.toLowerCase();
    return extension ? ['png', 'jpeg', 'jpg'].includes(extension) : false;
  }

  deleteImage(controller: any, id: any) {
    const txt = 'Are you sure you want to delete this?';
    const Yes = 'Yes';
    const No = 'No';
    Swal
      .fire({
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: Yes,
        cancelButtonText: No,
      })
      .then((result) => {
        if (result.value) {
          if (controller === 'attachment') {
            this.fileName = '';
            this.dateWithTime = ' ';
          }
          this.form.controls[controller].setValue('');
          const bannerImageElement: any = document.getElementById(
            id
          ) as HTMLImageElement;
          bannerImageElement.src = null;
        }
      });
  }


  deleteImageUser(controller: any, id: any) {
    const txt = 'Are you sure you want to delete this?';
    const Yes = 'Yes';
    const No = 'No';
    Swal
      .fire({
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: Yes,
        cancelButtonText: No,
      })
      .then((result) => {
        if (result.value) {
          if (controller === 'userImagePath') {
            this.userFileName = '';
            this.dateWithTime1 = ' ';
          }
          this.form.controls[controller].setValue('');
          const bannerImageElement: any = document.getElementById(
            id
          ) as HTMLImageElement;
          bannerImageElement.src = null;
        }
      });
  }

  removeSpecialCharacters(): void {
    const aadhaarControl = this.form.get('aadharNo');
    if (!aadhaarControl) return;

    let value = String(aadhaarControl.value || '');

    // Allow only digits
    value = value.replace(/[^0-9]/g, '');

    // Limit to 12 digits (Aadhaar length)
    if (value.length > 12) {
      value = value.substring(0, 12);
    }

    aadhaarControl.setValue(value, { emitEvent: false });
  }

}
